<template>
  <admin-wrapper :straight-title="additionalModuleName" :moduleEnabler="moduleEnabler" :hasButtons="false">
    <template #postForm>
      <admin-tabs-layers
        scope="masterplan_squares"
        :cols-attrs="{ lg: 12, xl: 11 }"
        class="pt-8"
        schema_scope="masterplan_squares"
        :tab-prop="tab"
      />
    </template>
  </admin-wrapper>
</template>

<script>
import { get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'MasterplanSquaresSettings',
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    additionalModuleName: get('admin/additionalModules@MASTERPLAN_SQUARES.verbose_name'),
    moduleEnabler() {
      return {
        name: 'masterplan_squares_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
};
</script>
